'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _reactCropper = require('react-cropper');

var _reactCropper2 = _interopRequireDefault(_reactCropper);

var _MozartButton = require('./../MozartButton/MozartButton');

var _MozartButton2 = _interopRequireDefault(_MozartButton);

var _MozartModal = require('./../MozartDialog/MozartModal/MozartModal');

var _MozartModal2 = _interopRequireDefault(_MozartModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MozartCropTool = function (_Component) {
  _inherits(MozartCropTool, _Component);

  function MozartCropTool(props) {
    _classCallCheck(this, MozartCropTool);

    var _this = _possibleConstructorReturn(this, (MozartCropTool.__proto__ || Object.getPrototypeOf(MozartCropTool)).call(this, props));

    _this.state = {
      modal_request: false,
      filename: 'No File Chosen',
      src: null,
      notification_modal: false,
      notification_description: '',
      cropResult: null,
      cropResultToUpload: null
    };
    return _this;
  }

  _createClass(MozartCropTool, [{
    key: 'onChange',
    value: function onChange(event) {
      var _this2 = this;

      event.preventDefault();
      var files = void 0;
      if (event.dataTransfer) {
        files = event.dataTransfer.files;
      } else if (event.target) {
        files = event.target.files;
      }
      if (files && files[0] && files[0].type.indexOf('image') !== -1 && files[0].name.match(/.(jpg|jpeg|png|gif|bmp)$/i) && parseInt(files[0].size, 10) < 1048576) {
        var reader = new FileReader();
        reader.onload = function () {
          _this2.setState({
            modal_request: true,
            filename: files[0].name,
            src: reader.result
          });
          _this2.props.openModal();
        };
        reader.readAsDataURL(files[0]);
      } else {
        this.setState({
          notification_modal: true,
          filename: 'No File Chosen',
          notification_description: 'Only allow image files and file size must be less than 1mb.'
        }, function () {
          if (files && files[0]) {
            files[0].value = null;
          }
        });
      }
    }
  }, {
    key: 'dataURItoBlob',
    value: function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString = '';
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var iaData = new Uint8Array(byteString.length);
      for (var count = 0; count < byteString.length; count++) {
        iaData[count] = byteString.charCodeAt(count);
      }
      return new Blob([iaData], { type: mimeString });
    }
  }, {
    key: 'cropImage',
    value: function cropImage(event) {
      var _this3 = this;

      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var originalData = this.cropper.getData();
      var width = originalData.width;
      if (width > 400) {
        width = this.props.width > 400 ? 400 : this.props.width;
      }
      if (width < 180) {
        width = 180;
      }

      if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
        return;
      }
      if (skip) {
        this.cropper.clear();
      }
      this.setState({
        modal_request: false,
        cropResultToUpload: this.dataURItoBlob(this.cropper.getCroppedCanvas({ width: width, height: 'auto' }).toDataURL()),
        cropResult: this.cropper.getCroppedCanvas().toDataURL()
      }, function () {
        _this3.props.update(_this3.state.src, _this3.state.cropResult, _this3.state.cropResultToUpload);
      });
      this.props.closeModal();
      if (this.props.customCropper) {
        this.props.onCropImage();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          customCropper = _props.customCropper,
          title = _props.title,
          skipCrop = _props.skipCrop,
          testId = _props.testId,
          themeId = _props.themeId;

      return _react2.default.createElement(
        _Grid2.default,
        { 'data-qa': testId, 'data-theme': themeId },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, md: 12 },
            _react2.default.createElement(_MozartModal2.default, {
              key: 'binary_cropper_dialog',
              title: title !== undefined ? title : 'Profile Cropper Tool',
              show: this.state.modal_request,
              disableSubmit: true,
              id: testId,
              onClose: this.cropImage.bind(this, {}, skipCrop),
              children: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactCropper2.default, {
                  key: 'cropper',
                  src: this.state.src,
                  style: { height: '340px', width: '100%' },
                  aspectRatio: this.props.ratio,
                  guides: false,
                  ref: function ref(cropper) {
                    _this4.cropper = cropper;
                  } }),
                _react2.default.createElement(
                  'div',
                  { style: { float: 'right', marginTop: '20px' } },
                  skipCrop && _react2.default.createElement(_MozartButton2.default, { data: 'Skip', onClick: this.cropImage.bind(this, {}, true), style: { marginRight: '10px', float: 'left' } }),
                  _react2.default.createElement(_MozartButton2.default, { data: 'Crop', onClick: this.cropImage.bind(this), style: { float: 'left' } })
                )
              )
            }),
            !customCropper && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { style: { fontSize: '0.9em', marginTop: '20px' } },
                _react2.default.createElement(
                  'cite',
                  null,
                  '*Image File (Should be in png, jpeg, gif and bmp format)'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement('input', { style: { width: '90px', color: 'transparent' }, type: 'file', accept: 'image/*', onChange: this.onChange.bind(this) }),
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.filename
                )
              )
            ),
            customCropper && _react2.default.createElement(
              'p',
              { style: { margin: '0px' }, onClick: function onClick() {
                  document.getElementById('file_uploader').click();
                } },
              this.props.cropperNode,
              _react2.default.createElement('input', { id: 'file_uploader', style: { width: '90px', color: 'transparent', visibility: 'hidden', height: '0px' }, type: 'file', accept: 'image/*', onChange: this.onChange.bind(this) })
            )
          )
        ),
        _react2.default.createElement(
          _MozartModal2.default,
          {
            title: 'Notification',
            show: this.state.notification_modal,
            disableSubmit: true,
            id: testId,
            onClose: function onClose() {
              _this4.setState({ notification_modal: false });
            }
          },
          this.state.notification_description
        )
      );
    }
  }]);

  return MozartCropTool;
}(_react.Component);

MozartCropTool.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** if true close the modal */
  closeModal: _propTypes2.default.func,
  /** if true open modal */
  openModal: _propTypes2.default.func,
  /** callback when custom crop */
  onCropImage: _propTypes2.default.func,
  /** update callback   after crop */
  update: _propTypes2.default.func,
  /** ratio for the image */
  ratio: _propTypes2.default.number,
  /** image width */
  width: _propTypes2.default.number,
  /** if true crop is customed */
  customCropper: _propTypes2.default.bool,
  /** node that trigger crop modal */
  cropperNode: _propTypes2.default.object,
  /** crop title for modal */
  title: _propTypes2.default.string,
  /** if true no crop */
  skipCrop: _propTypes2.default.bool
};
MozartCropTool.defaultProps = {
  ratio: undefined,
  width: 400,
  customCropper: false,
  skipCrop: false,
  testId: 'MozartCropTool',
  themeId: 'MozartCropTool'
};
exports.default = MozartCropTool;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartCropTool/MozartCropTool.js
// module id = 2112
// module chunks = 1